"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.find.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputSelect = require("@citrus/input-select");
var _inputVisualPicker = require("@citrus/input-visual-picker");
var _tag = require("@citrus/tag");
var _inputSearch = require("@citrus/input-search");
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Constants");
var _utils = require("@pcty/utils");
require("./index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctyQuestionBuilderQuestionBankSelection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctyQuestionBuilderQuestionBankSelection, _Component);
  var _super = _createSuper(PctyQuestionBuilderQuestionBankSelection);
  function PctyQuestionBuilderQuestionBankSelection(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctyQuestionBuilderQuestionBankSelection);
    _this = _super.call(this, props);
    _this.state = {
      selectedCategory: undefined,
      searchText: ''
    };
    _this.onQuestionsChange = _this.onQuestionsChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChangeCategoryType = _this.onChangeCategoryType.bind((0, _assertThisInitialized2.default)(_this));
    _this.onQuestionSearch = _this.onQuestionSearch.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctyQuestionBuilderQuestionBankSelection, [{
    key: "onQuestionsChange",
    value: function onQuestionsChange(event) {
      var selectedQbItemIds = [].concat((0, _toConsumableArray2.default)(this.props.selectedQbItemIds), (0, _toConsumableArray2.default)(event.selectedValues));
      // get just the unique ones to save since there are now duplicates
      selectedQbItemIds = selectedQbItemIds.filter(function (c, index) {
        return selectedQbItemIds.indexOf(c) === index;
      });

      // if user unselected an item, it won't be in the selectedValues but will be in the state list
      if (event.selectedValues.indexOf(event.clicked.value) < 0 && selectedQbItemIds.indexOf(event.clicked.value) >= 0) {
        var srcIndex = selectedQbItemIds.indexOf(event.clicked.value);
        // remove the item
        selectedQbItemIds.splice(srcIndex, 1);
      }
      this.props.onQuestionsChange(selectedQbItemIds);
    }
  }, {
    key: "onQuestionSearch",
    value: function onQuestionSearch(value) {
      this.setState({
        searchText: value
      });
    }
  }, {
    key: "onChangeCategoryType",
    value: function onChangeCategoryType(selected) {
      this.setState({
        selectedCategory: selected
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var instructions = 'Select pre-configured questions to add to your surveys. These questions are unable to be edited.';

      // filter by the selected category
      var categoryCount = 0;
      var filteredQuestions = (0, _toConsumableArray2.default)(this.props.questionBankData);
      if (this.state.selectedCategory && !(0, _utils.isNullOrEmpty)(this.state.selectedCategory.value)) {
        filteredQuestions = filteredQuestions.filter(function (x) {
          return x.questionBankCategoryDescription === _this2.state.selectedCategory.value;
        });
        categoryCount = filteredQuestions.length;
      }

      // filter by the search text
      if (!(0, _utils.isNullOrEmpty)(this.state.searchText)) {
        filteredQuestions = filteredQuestions.filter(function (x) {
          return x.questionText.toLowerCase().indexOf(_this2.state.searchText.toLowerCase()) > -1;
        });
      }

      // build list of indexes from the selectedQbItemIds
      var selectedIndexes = [];
      this.props.selectedQbItemIds.map(function (sq) {
        var index = filteredQuestions.findIndex(function (x) {
          return x.citrusElement.id === sq;
        });
        if (index >= 0) {
          selectedIndexes.push(index);
        }
      });

      // iterate and render!
      var pickerItems = filteredQuestions.map(function (q) {
        var fixedTitle = (0, _PctyQuestionBuilder.limitText)(q.questionText, 150, true); // extract, trim, fix up the titles
        var isExisting = _this2.props.excludedQbItemIds.indexOf(q.questionGuid) >= 0;
        var questionType = _PctyQuestionBuilder2.QUESTION_TYPES_LIST.find(function (x) {
          return x.questionTypeId === q.citrusElement.typeId;
        });
        return /*#__PURE__*/_react.default.createElement(_inputVisualPicker.VisualPicker.Item, {
          key: q.citrusElement.key,
          label: fixedTitle,
          value: q.citrusElement.id,
          disabled: isExisting,
          footer: q.questionBankCategoryDescription,
          renderFooterActionArea: function renderFooterActionArea() {
            return /*#__PURE__*/_react.default.createElement(_tag.Tag, {
              value: questionType.label
            });
          }
        });
      });
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", {
        className: "pcty-margin-bottom"
      }, instructions), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-bottom pcty-padding-all pcty-border-top pcty-border-bottom",
        style: {
          backgroundColor: '#f5f5f5'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_inputSearch.Search, {
        automationId: "question-bank-search",
        id: "question-bank-search",
        placeholder: "Search questions",
        onChange: function onChange(event) {
          return _this2.onQuestionSearch(event.value);
        },
        onClear: function onClear() {
          return _this2.onQuestionSearch('');
        },
        value: this.state.searchText
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement(_inputSelect.SelectStatic, {
        automationId: "select-category-type",
        id: "select-category-type",
        className: 'render-type-options',
        onChange: this.onChangeCategoryType,
        options: this.props.categoryOptions,
        placeholder: "All Categories",
        value: this.state.selectedCategory
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-bottom pcty-border-bottom pcty-padding-bottom"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, !(0, _utils.isNullOrEmpty)(this.state.selectedCategory) && !(0, _utils.isNullOrEmpty)(this.state.selectedCategory.value) && /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-type-semibold"
      }, /*#__PURE__*/_react.default.createElement("p", null, "".concat(this.state.selectedCategory.label, " (").concat(categoryCount, ")")))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-6"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-type-semibold pcty-float-right"
      }, /*#__PURE__*/_react.default.createElement("p", null, "Total Selected: ".concat(this.props.selectedQbItemIds.length))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-top"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_inputVisualPicker.VisualPicker, {
        id: "question-bank-visual-picker",
        maxColumns: 2,
        stretch: false,
        onChange: this.onQuestionsChange,
        selectedIndexes: selectedIndexes
      }, pickerItems))));
    }
  }]);
  return PctyQuestionBuilderQuestionBankSelection;
}(_react.Component);
PctyQuestionBuilderQuestionBankSelection.propTypes = {
  questionBankData: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  selectedQbItemIds: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  categoryOptions: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  excludedQbItemIds: _propTypes.default.arrayOf(_propTypes.default.any).isRequired,
  onQuestionsChange: _propTypes.default.func.isRequired
};
var _default = exports.default = PctyQuestionBuilderQuestionBankSelection;